<template>
  <div class="home-3">
    <layouts-header></layouts-header>
    <home-three-banner></home-three-banner>
    <feature-course></feature-course>
    <trending-course></trending-course>
    <share-knowledge></share-knowledge>
    <latest-blog></latest-blog>
    <home-three-footer></home-three-footer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
